import React, { Component } from 'react'
import { connect } from 'react-redux'
import { beautifyPhone } from 'utils/stuff'

import TextField from 'material-ui/TextField'


let select = (state) => state


export class InputMoney extends Component {
	constructor(props) {
		super(props);
			this.state = {
				value: (this.props.value)?this.props.value:'',

			}
		}
		componentDidMount(){
			if (this.props.value){

				this.setState({value: this.props.value.toString()})

			}
		}
		render() {
			return (
				<div style={{...this.props.style}}>
					<TextField
						disabled={(this.props.disabled)?this.props.disabled:false}
						className={(this.props.className)?this.props.className:""}
						inputStyle={(this.props.inputStyle)?this.props.inputStyle:{fontSize: "16", color:"#000000"}}
						underlineStyle={(this.props.underlineStyle)?this.props.underlineStyle: {borderBottom: "0px solid"}}
						hintText={(this.props.hintText)?this.props.hintText:"Enter phone"}
						hintStyle={(this.props.hintStyle)?this.props.hintStyle:{fontStyle: "italic", fontSize: "14px"}}
						fullWidth={true}
						onChange={(evt) => {
							let carret = evt.currentTarget.selectionStart
							let newVal = beautifyPhone(evt.target.value)
							if(this.state.value && evt.target.value.replace(/\D/g, '').length >= this.state.value.replace(/\D/g, '').length){
								if(newVal.length - evt.target.value.length == 1) carret = carret + 1
							}
							this.setState({value: newVal})
						}}
						value={this.state.value}
						floatingLabelText={(this.props.floatingLabelText)?this.props.floatingLabelText:''}
						key={(this.props.key)?this.props.key:''}
						ref={(this.props.ref)?this.props.ref:''}
						onChange={(evt) => {
							debugger
							let carret = evt.currentTarget.selectionStart
							let specCharIndxs = [1, 4, 5, 6, 9]
							if(evt.target.value.replace(/\D/g, '').length >= this.state.value.replace(/\D/g, '').length){
								if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
								if(carret == 4) carret = carret + 1
								if(carret == 5) carret = carret + 1
							}
							this.setState({value: beautifyPhone(evt.target.value)})
						}}
						onBlur={(evt) => this.props.onBlur((/\d/.test(evt.target.value)?evt.target.value:""))}
					/>
				</div>
			)
		}
}

export default connect(select)(InputMoney)



// WEBPACK FOOTER //
// ./src/components/InputPhone.js